import { createDynamicSlice } from ".";
import { getRoleListThunk } from "../thunks/rolesThunk";

export const rolesSlice = createDynamicSlice({
  name: "roles",
  thunk: getRoleListThunk,
  listMode: true,
  resetActionName: "resetRoles",
});

export const rolesReducer = rolesSlice.reducer;
export const { resetRoles } = rolesSlice.actions;
